import React, { Component, createElement, Fragment } from 'react';
import { Button, message, Modal, Badge, Table, Typography, Radio } from 'antd';
import { connect } from 'react-redux';
import builder, { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { get, map } from 'lodash';
import { errorHandle } from '../../services';
const { confirm } = Modal;
const api = services.api;
const { Text } = Typography;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface IState {
    selectedKeys: any;
    visible: boolean;
    wsConnected: boolean;
}

class deliveryOrder extends Component<CategoryFilterAttrTableProps, IState> {
    private ws: WebSocket | null = null;
    private wsPromise: Promise<void> | null = null;
    private failCountFromApi: number = 0; // 保存API层面的失败数量

    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            visible: false,
            wsConnected: false,
        };
        this.onDeleteAll = this.onDeleteAll.bind(this);
        this.connectWebSocket = this.connectWebSocket.bind(this);
        this.closeWebSocket = this.closeWebSocket.bind(this);
    }

    showModal = () => {
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少勾选1条数据');
        } else if (selectedKeys.length > 10) {
            message.warning('单次最多打印10张，请分批次打印');
        } else {
            // 先建立 WebSocket 连接
            const wsConnectPromise = this.connectWebSocket();

            let itemIds = selectedKeys.join(',');
            console.log(itemIds.toString(''), typeof itemIds.toString(''));

            api.post(selectedKeys, {
                apiPath: `/shippingOrderNew/pullData`,
            })
                .then(async (res: any) => {
                    if (res.code !== '1') {
                        // 状态码不是1，提示异常信息
                        message.error('获取打印数据失败，请稍后重试');
                        this.closeWebSocket();
                        return;
                    }

                    let finalPrintData = [];

                    // 重置之前的失败计数
                    this.failCountFromApi = 0;

                    if (res.prePrintDatas && res.prePrintDatas.length > 0) {
                        // 使用 filter 获取所有有效的打印数据（code为"1"且perPrintData不为空）
                        const validItems = res.prePrintDatas.filter((item: any) => {
                            // 只有code为"1"且perPrintData不为空的才是有效数据
                            return (
                                item.code === '1' &&
                                item.perPrintData &&
                                item.perPrintData.trim() !== ''
                            );
                        });
                        // 将有效数据转换为数组
                        finalPrintData = validItems.map((item: any) => item.perPrintData);

                        // 统计code不为"1"的失败数量
                        const failedItems = res.prePrintDatas.filter((item: any) => {
                            return item.code !== '1';
                        });
                        this.failCountFromApi = failedItems.length;
                    }

                    // 如果有API层面的失败，记录到日志中
                    if (this.failCountFromApi > 0) {
                        console.log(`API获取数据时失败 ${this.failCountFromApi} 条`);
                    }

                    const printData = {
                        orderType: 'PRINT',
                        key: res.objectId,
                        parameters: {
                            tempUrl: res.tempUrl,
                            printData: finalPrintData,
                        },
                    };

                    // 等待 WebSocket 连接建立后再发送数据
                    try {
                        await wsConnectPromise;

                        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                            this.ws.send(JSON.stringify(printData));
                            console.log('WebSocket消息已发送:', printData);
                        } else {
                            message.error('WebSocket连接未建立，打印失败');
                            this.closeWebSocket();
                        }
                    } catch (error) {
                        console.error('WebSocket连接失败:', error);
                        message.error('京东打印组件未运行，请启动后再试');
                    }
                })
                .catch((error) => {
                    errorHandle(error);
                    this.closeWebSocket();
                });

            this.setState({
                visible: true,
            });
        }
    };

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;
        const params = {
            page,
            perPage,
            ...filters,
        };
        api.post(params, { apiPath: `/shippingOrder/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    connectWebSocket(): Promise<void> {
        // 如果已有连接且处于打开状态，直接返回
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            return Promise.resolve();
        }

        // 如果正在连接中，返回现有的 Promise
        if (this.wsPromise) {
            return this.wsPromise;
        }

        // 创建新的连接 Promise
        this.wsPromise = new Promise((resolve, reject) => {
            try {
                // 创建WebSocket连接
                this.ws = new WebSocket('ws://localhost:9113');

                this.ws.onopen = () => {
                    console.log('WebSocket连接已建立');
                    this.setState({ wsConnected: true });
                    this.wsPromise = null;
                    resolve();
                };

                this.ws.onmessage = (event) => {
                    try {
                        const response = JSON.parse(event.data);
                        console.log('收到WebSocket消息:', response);

                        // 解析成功和失败数量
                        let successCount = 0;
                        let failCount = 0;

                        // total 格式：请求面单数 + "-" + 成功渲染输出面单数
                        if (response.detailinfo && response.detailinfo.total) {
                            const totalStr = response.detailinfo.total;
                            const parts = totalStr.split('-');
                            if (parts.length === 2) {
                                const requestCount = parseInt(parts[0]) || 0;
                                successCount = parseInt(parts[1]) || 0;
                                // 失败数量 = 请求数量 - 成功数量
                                failCount = requestCount - successCount;
                            }
                        }

                        // 如果 errors 数组有内容，使用 errors 数组的长度作为失败数量
                        if (
                            response.detailinfo &&
                            response.detailinfo.errors &&
                            response.detailinfo.errors.length > 0
                        ) {
                            failCount = response.detailinfo.errors.length;
                        }

                        // 汇总API层面的失败数量
                        failCount += this.failCountFromApi;

                        // 根据数量显示不同的提示
                        if (successCount > 0 && failCount === 0) {
                            message.success(`已成功打印 ${successCount} 张面单`);
                        } else if (successCount === 0 && failCount > 0) {
                            message.error(`打印失败，请检查打印机连接或联系技术支持`);
                        } else if (successCount > 0 && failCount > 0) {
                            message.info(`成功打印 ${successCount} 张，失败 ${failCount} 张`);
                        } else {
                            // 回退到原有逻辑
                            if (response.success === true || response.success === 'true') {
                                message.success(response.message || '打印成功');
                            } else {
                                message.error(response.message || '打印失败');
                            }
                        }

                        // 收到响应后关闭连接
                        this.closeWebSocket();
                    } catch (e) {
                        console.error('解析WebSocket消息失败:', e);
                    }
                };

                this.ws.onerror = (error) => {
                    console.error('WebSocket错误:', error);
                    this.setState({ wsConnected: false });
                    this.wsPromise = null;
                    reject(error);
                };

                this.ws.onclose = () => {
                    console.log('WebSocket连接已关闭');
                    this.setState({ wsConnected: false });
                    this.ws = null;
                    this.wsPromise = null;
                };
            } catch (error) {
                this.wsPromise = null;
                reject(error);
            }
        });

        return this.wsPromise;
    }

    closeWebSocket() {
        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
        this.wsPromise = null;
    }

    componentDidMount(): void {
        const { entity }: any = this.props;
    }

    componentWillUnmount(): void {
        this.closeWebSocket();
    }

    renderTable() {
        const { entity, componentId, result }: any = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            loadFirstPage: true,
            switchRefresh: true,
            params: {},
            rowSelection: {
                getCheckboxProps: (record): any => {
                    record.disabled = false;
                    if (
                        record.deliveryStatus == 2 ||
                        record.deliveryStatus == 3 ||
                        record.deliveryStatus == 4 ||
                        record.deliveryWay == 1
                    )
                        record.disabled = true;
                    return record;
                },
                onChange: (selectedKeys: string[]) => {
                    const selectSendOrder = map(selectedKeys, (index) =>
                        get(result[index], 'expressNumber')
                    );
                    this.setState({
                        selectedKeys: selectSendOrder,
                    });
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '50', '100'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'expressName',
                },
                {
                    property: 'expressNumber',
                },
                {
                    property: 'orderNo',
                },
                {
                    property: 'updateTimeStr',
                },
                {
                    property: 'orderType',
                },
                {
                    property: 'printTimes',
                },
                {
                    property: 'receiverName',
                },
                {
                    property: 'mobile',
                },
                {
                    property: 'address',
                },
            ],
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        return (
            <Fragment>
                <div className="optionBox">
                    <Button type="primary" onClick={this.showModal} style={{ margin: '0 20px' }}>
                        打印京东面单
                    </Button>
                </div>
                {this.renderTable()}
            </Fragment>
        );
    }
}

function mapStateTopProps(state: any, props: any) {
    const {
        entity: { result },
        entity,
        componentId,
    } = props;
    return {
        result,
        entity,
        componentId,
    };
}

export const DeliveryOrder = connect(mapStateTopProps)(deliveryOrder);
